
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import vSelect from "vue-select"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class ChartOptions extends Vue {
	@Prop()
	value: any;

	@Prop({ default: "ColumnChart" })
	chartType: any;

	@Prop()
	columns!: any[]

	@Prop()
	chartData: any;

	get markerColumns () {
		if (!this.columns) return []
		return this.columns.filter(c => c.dataType === "map-marker")
	}

	public mounted () {
		if (!this.value) {
			this.value = {}
			this.$emit("input", { })
		}
	}

	get seriesTitles () {
		if (this.chartData) {
			return this.chartData[0].filter((d: any) => d.role !== "annotation")
		} else {
			// Temp fix to allow series selection in dashboard tile for comboChart
			return ["header", "Series 0", "Series 1", "Series 2", "Series 3", "Series 4", "Series 5", "Series 6", "Series 7", "Series 8", "Series 9"]
		}
	}
}

